<template>
  <el-dialog title="选择商户" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="商户等级" v-if="storeType === 10">
          <el-select v-model="formInline.level" placeholder="选择商户等级" clearable>
            <el-option v-for="(item, index) in levelList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称">
          <el-input placeholder="请输入商户名称" v-model="formInline.search">
            <el-button slot="append" icon="el-icon-productName" @click="getData">查询</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" highlight-current-row v-loading="loading">
          <el-table-column prop="shopSupplierId" label="商户ID" width="90"></el-table-column>
          <el-table-column prop="name" label="商户名称"></el-table-column>
          <!--          <el-table-column label="logo" width="80">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-image v-if="scope.row.logoId" :src="scope.row.logoFilePath"-->
          <!--                        width="50" height="50" :preview-src-list="getLogoList(scope.$index)"/>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="linkName" label="联系人" width="90"></el-table-column>
          <el-table-column prop="linkPhone" label="联系电话" width="120"></el-table-column>
          <el-table-column prop="address" label="联系地址"></el-table-column>
          <el-table-column width="80" label="单选">
            <template slot-scope="scope">
              <el-button size="mini" v-if="scope.row.noChoose" @click="SingleFunc(scope.row)">选择</el-button>
              <el-button size="mini" v-else disabled>已选</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                       :current-page="curPage" :page-sizes="[2, 10, 20, 50, 100]" :page-size="pageSize"
                       layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible=false">取 消</el-button>
      <!--      <el-button size="small" type="primary" @click="addClerk">确 定</el-button>-->
    </div>
  </el-dialog>
</template>

<script>
import SupplierApi from '@/api/supplier.js'

export default {
  name: 'SupplierChoose',
  props: {
    storeType: {
      type: Number
    },
    excludeIds: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      dialogVisible: false,
      loading: true,
      levelList: [{
        id: 0,
        name: '一级分销商'
      }, {
        id: 1,
        name: '二级分销商'
      }, {
        id: 2,
        name: '三级分销商'
      }, {
        id: 3,
        name: '四级分销商'
      }, {
        id: 4,
        name: '五级分销商'
      }],
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        search: '',
        level: undefined
      },
      logoImgs: [],
      multipleSelection: [],
      /*结果类别*/
      type: 'error',
      /*传出去的参数*/
      params: null
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },

    getLogoList (index) {
      return this.logoImgs.slice(index).concat(this.logoImgs.slice(0, index))
    },

    show () {
      this.params = null
      this.type = 'error'
      this.multipleSelection = []
      this.formInline = {
        search: '',
        level: undefined
      }
      this.curPage = 1
      this.getData()
      this.dialogVisible = true
    },

    /*关闭弹窗*/
    dialogFormVisible (e) {
      this.$emit('closeDialog', {
        type: this.type,
        openDialog: false,
        params: this.params
      })
    },

    /*选择第几页*/
    handleCurrentChange (val) {
      this.curPage = val
      this.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getData()
    },

    getData () {
      let self = this
      let Params = this.formInline
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      if (this.excludeIds && this.excludeIds.length) {
        Params.excludeIds = this.excludeIds
      }
      if (this.storeType && this.storeType > 0) {
        Params.storeType = this.storeType
      }
      SupplierApi.getSupplierList(Params)
        .then(res => {
          self.loading = false
          self.tableData = res.data.records.map(child => {
            child.noChoose = true
            return child
          })
          self.totalDataNumber = res.data.total
        })
        .catch(error => {
          self.loading = false
        })
    },
    /*单选*/
    SingleFunc (row) {
      this.multipleSelection = [row]
      this.addClerk()
    },
    addClerk () {
      let self = this
      let params = null
      let type = 'success'
      if (self.multipleSelection.length < 1) {
        self.$message({
          message: '请至少选择一件产品商品！',
          type: 'error'
        })
        return
      }
      params = self.multipleSelection[0]
      self.params = params
      self.type = 'success'
      self.dialogVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/dialog/SupplierChoose.vue